import { PayloadAction } from '@lifesize/typescript-react-redux-utils';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import DeviceActions from 'actions/deviceCustomizationActions';
import { actions as ModalActions } from 'actions/modalActions';
import { actions as SelectionActions } from 'actions/selectionActions';
import { Actions as ActionTypes } from 'constants/deviceCustomizationConstants';
import { FEATURE_FLAG_ALEXA_INTEGRATION, FEATURE_FLAG_THIRD_PARTY_BUTTONS } from 'constants/featureFlags';
import { ModalTypes } from 'constants/modalConstants';
import { SelectionInterface } from 'state/Selection';
import { getClient } from 'nucleus-apollo-client';
import { RoomSystem } from 'typings/types';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import gql from 'graphql-tag';
import { generateURLForPhoneHD } from 'utils/roomSystemUtils';
import { featureSelectors } from '@lifesize/nucleus';
import { selectAlexaDevices } from 'selectors/alexaIntegrationSelector';
import { DeviceRegistration } from 'constants/alexaIntegrationConstants';

const deviceCustomizationMiddleware =
  (store: MiddlewareAPI) =>
    (next: Dispatch) => {
      return async (action: PayloadAction<ActionTypes.OPEN_DEVICE_CUSTOMIZATION, { serialNumber: string }>) => {
        if (ActionTypes.OPEN_DEVICE_CUSTOMIZATION !== action.type) {
          return next(action);
        }
        const myState = store.getState();
        const selectionState = myState.app.get('selection', null) as SelectionInterface;
        let selectionArray = [];
        const devices: RoomSystem[] = [];

        if (action.payload && action.payload.serialNumber) {
          selectionArray.push(action.payload.serialNumber);
        } else {
          selectionArray = selectionState.selection;
        }

        const client = await getClient(store.dispatch);
        const state = store.getState();

        selectionArray.map((selection) => {
          const data = client.readFragment({
            id: selection,
            fragment: gql`
            fragment myRS on RoomSystem {
              serialNumber
              dialstring
              displayName
              __typename
            }
          `,
          }) as RoomSystem;

          if (data) {
            const alexaIntegrationDeviceState = selectAlexaDevices(state)[data.serialNumber];
            data.alexaIntegration = featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_ALEXA_INTEGRATION) && _get(alexaIntegrationDeviceState, 'state') === DeviceRegistration.CONNECTED;

            devices.push(data);
          }
        });

        const dialStringArray = devices.map((d) => d.dialstring || '');

        const deviceName = (_isEmpty(devices) || devices.length > 1) ? 'Lifesize Phone HD' : devices[0].displayName || '';
        const alexaIntegration = _isEmpty(devices) ? false : devices[0].alexaIntegration;

        const features = {
          thirdPartyButtons: featureSelectors.getFeatureFlag(state)(FEATURE_FLAG_THIRD_PARTY_BUTTONS),
          alexaIntegration
        };

        const url = generateURLForPhoneHD(dialStringArray, deviceName, features);
        if (url.length) {
          next(DeviceActions.setDeviceCustomizationUrl({ url }));
          next(ModalActions.openModal({ modalType: ModalTypes.DEVICE_CUSTOMIZATION }));
          next(SelectionActions.resetSelection());
          return null;
        }
        return null;
      };
    };

export default (deviceCustomizationMiddleware as Middleware);
